import React, { useEffect, useMemo, useState } from 'react';

import { calculateRowTotals } from '../../utils/calculations';
import { getIndentClass } from '../../utils/styleUtils';

import RevenueMilestoneData from './RevenueMilestoneData';
import UncommittedRow from './UncommittedRow';

import { formatFigure } from 'Helpers/formatService';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function UncommittedSection(props) {
    const [showUncommittedChildren, setShowUncommittedChildren] = useState(false);

    // Handle expand all trigger from parent with staggered updates
    useEffect(() => {
        const t = props.expandAllTrigger;
        if (!t?.version) return;

        if (t.batch === 'uncommitted' || t.batch === 'projects uncommitted') {
            setShowUncommittedChildren(t.expanded);
        }
    }, [props.expandAllTrigger?.version]);

    // Calculate indentation level
    const indentLevel = props.indentLevel;
    const childIndentLevel = indentLevel + 1;

    const toggleUncommittedShow = () => {
        setShowUncommittedChildren(!showUncommittedChildren);
    };

    const uncommitted = props.revenue.uncommitted;
    if (!uncommitted) return null;

    const { maxRevenueMilestonesCount } = props;

    const totals = useMemo(() => {
        return calculateRowTotals(uncommitted.currentMilestones);
    }, [uncommitted.currentMilestones]);

    return (
        <>
            <tr className="!tw-bg-gray-50">
                <td>
                    <div className={`tw-flex tw-items-center tw-gap-x-1.5 tw-cursor-pointer ${getIndentClass(indentLevel)}`} onClick={toggleUncommittedShow}>
                        <div className="tw-font-medium tw-text-gray-700">{$t('Uncommitted')}</div>
                        <div>{showUncommittedChildren ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                    </div>
                </td>
                <td className="tw-p-4"></td>
                <td className="tw-p-4 tw-text-right tw-text-gray-700 tw-border-r-2">{formatFigure(uncommitted.value)}</td>
                {uncommitted.currentMilestones &&
                    [...Array(maxRevenueMilestonesCount)].map((e, i) => {
                        return (
                            <React.Fragment key={`uncommitted_milestones_${i}`}>
                                <RevenueMilestoneData
                                    key={`${props.keyPrefix || ''}uncommitted_${props.revenue.id}_milestone_${i}`}
                                    milestones={uncommitted.currentMilestones}
                                    milestoneId={i}
                                    keyPrefix={props.keyPrefix || ''}
                                    amountOnly={true}
                                    isCommitted={false}
                                />
                            </React.Fragment>
                        );
                    })}
                <td className="tw-p-4 tw-text-right"></td>
                <td className="tw-p-4 tw-text-right">{formatFigure(totals.totalValue)}</td>
                <td className="tw-p-4 tw-text-right"></td>
            </tr>
            {showUncommittedChildren && (
                <>
                    {/* Revenue milestones are single type, so we show them directly without type splitting */}
                    <UncommittedRow
                        {...props}
                        key={`uncommitted_${props.revenue.id}`}
                        type="cash"
                        label="Cash"
                        data={uncommitted}
                        periods={props.periods}
                        indentLevel={childIndentLevel}
                        revenue={props.revenue}
                        totalUncommittedValue={uncommitted.value}
                    />
                </>
            )}
        </>
    );
}
